import Analytics from '../../../modules/analytics';

export const sendClick = action => wrappedFunction => e => {
  Analytics.track(`client_proprofile_${action}`);
  return wrappedFunction(e);
};
